//
//
//
//
//
//
//
//
//
//

import BaseInput from '../BaseInput'
export default {
  name: 'CycleHiddenInput',
  extends: BaseInput,
  methods: {
    updateValue(event) {
      this.$emit('input', event.target.value)
    }
  }
}
